import React from 'react'

export default function LeagueCard({
  league,
  selected,
  disabled,
  onClick,
  onKeyDown,
}) {
  return (
    <button
      className={`league-card ${selected ? 'selected' : ''} ${
        disabled ? 'already-registered' : ''
      }`}
      role="radio"
      aria-checked={selected && !disabled}
      aria-disabled={disabled}
      onKeyDown={onKeyDown}
      disabled={disabled}
      onClick={onClick}
    >
      <div className="league-card-content">
        <h3>{league.name}</h3>
        <span className="league-type">Join {league.league_type}</span>
        {selected && !disabled && (
          <span className="selected-badge" aria-hidden="true">
            ✔ Selected
          </span>
        )}
        {disabled && (
          <div className="registration-badge">✓ Already Registered</div>
        )}
      </div>
    </button>
  )
}
